// "Complete the set" (snippets/complete-set.liquid): keeps the set total current and adds both
// items as separate line items, then opens the cart drawer.
// Delegated, because Dawn re-renders the block when the main variant changes.
(function () {
  if (window.sambobCompleteSet) return;
  window.sambobCompleteSet = true;

  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function updateTotal(set) {
    const option = set.querySelector('select[name="id"]').selectedOptions[0];
    const total = Number(set.dataset.mainPrice) + Number(option.dataset.price);
    set.querySelector('[data-complete-set-amount]').textContent = set.dataset.totalTemplate.replace(
      '__AMOUNT__',
      formatMoney(total, set.dataset.moneyFormat)
    );
    const shipping = set.querySelector('[data-complete-set-shipping]');
    const threshold = Number(set.dataset.threshold);
    if (shipping) shipping.hidden = !(threshold && total >= threshold);
  }

  function showMessage(set, text) {
    const message = set.querySelector('.complete-set__message');
    message.textContent = text;
    message.hidden = false;
  }

  document.addEventListener('change', (event) => {
    const set = event.target.closest('[data-complete-set]');
    if (set && event.target.matches('select[name="id"]')) updateTotal(set);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-complete-set-add]');
    if (!button) return;
    const set = button.closest('[data-complete-set]');
    const partnerId = set.querySelector('select[name="id"]').value;
    const cartDrawer = document.querySelector('cart-drawer');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(set.dataset.mainVariant), quantity: 1 },
            { id: Number(partnerId), quantity: 1 },
          ],
          sections: cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || response.status);
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(state);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      console.error('Complete the set failed', error);
      showMessage(set, (window.sambobCompleteSetStrings || {}).error || String(error.message || error));
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
